<script setup lang="ts">
import { ref, watch } from 'vue'
import Dialog from 'primevue/dialog'
import InputText from 'primevue/inputtext'
import Button from 'primevue/button'
import { useVehicleStore } from '@/stores/vehicleStore'
import { type Vehicle } from '@/types/Vehicle'

const modelValue = defineModel<boolean>()
const emit = defineEmits<{
  (e: 'save', vehicle: Vehicle): void
}>()

const props = defineProps<{
  vehicle: Vehicle
}>()

const workingCopy = ref<Vehicle>({ ...props.vehicle })
const saving = ref(false)
const vehicleStore = useVehicleStore()

watch(
  () => props.vehicle,
  (val) => {
    workingCopy.value = { ...val }
  },
)

async function save() {
  saving.value = true
  const updated = workingCopy.value.id
    ? await vehicleStore.update(workingCopy.value)
    : await vehicleStore.add(workingCopy.value)
  emit('save', workingCopy.value)
  modelValue.value = false
  saving.value = false
}
</script>

<template>
  <Dialog
    v-model:visible="modelValue"
    :header="workingCopy.id ? 'Edit Vehicle' : 'Create Vehicle'"
    modal
    class="w-[500px]"
  >
    <div class="space-y-4">
      <div class="flex gap-2">
        <InputText v-model="workingCopy.tagNumber" placeholder="Tag Number" class="w-1/2" />
        <InputText v-model="workingCopy.state" placeholder="State" class="w-1/2" />
      </div>
      <div class="flex gap-2">
        <InputText
          :model-value="workingCopy.year?.toString() || ''"
          placeholder="Year"
          class="w-1/3"
          type="number"
          @update:model-value="
            (val: string | undefined) => (workingCopy.year = val ? Number(val) : undefined)
          "
        />
        <InputText v-model="workingCopy.make" placeholder="Make" class="w-1/3" />
        <InputText v-model="workingCopy.model" placeholder="Model" class="w-1/3" />
      </div>
      <InputText v-model="workingCopy.color" placeholder="Color" class="w-full" />
      <InputText v-model="workingCopy.vin" placeholder="VIN" class="w-full" />
      <InputText v-model="workingCopy.notes" placeholder="Notes" class="w-full" />

      <div class="text-right">
        <Button label="Save" icon="pi pi-check" @click="save" :loading="saving" />
      </div>
    </div>
  </Dialog>
</template>
